"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flag = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var Flag = function (_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.colors.black : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: style },
        React.createElement("defs", null,
            React.createElement("path", { d: "M17,10 L19,5 L7,5 C7,4.4 6.6,4 6,4 C5.4,4 5,4.4 5,5 L5,19 C5,19.6 5.4,20 6,20 C6.6,20 7,19.6 7,19 L7,15 L19,15 L17,10 Z", id: "SVG_ICON_FLAG_PATH_1" })),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "SVG_ICON_FLAG_MASK_1", fill: "white" },
                React.createElement("use", { xlinkHref: "#SVG_ICON_FLAG_PATH_1" })),
            React.createElement("g", { fillRule: "nonzero" }),
            React.createElement("g", { mask: "url(#SVG_ICON_FLAG_MASK_1)", fill: color },
                React.createElement("rect", { x: "0", y: "0", width: "24", height: "24" })))));
};
exports.Flag = Flag;
//# sourceMappingURL=Flag.js.map